module.exports = __webpack_public_path__ + "static/img/intercept-bg.ac74c63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/intercept-bg.png
// module id = GNlM
// module chunks = 96